﻿"use strict";
/*make it possible to search case insensitive*/
jQuery.expr[':'].icontains = function (a, i, m) {
	return jQuery(a).text().toUpperCase()
		.indexOf(m[3].toUpperCase()) >= 0;
};

/* Focus element */
jQuery.fn.extend({
	scrollToMe: function () {
		var x = jQuery(this).offset().top - 300;
		jQuery('#content').animate({ scrollTop: x }, 500);
	}
});

window.focusElement = function (selectizeObjectForElement, elementId) {
	// Focus the required control
	try {
		if (selectizeObjectForElement) {
			/* Depends on selectize internal implementation! */

			// When the selectized input is focused, its dropdown is automatically open.
			// The opening can be suppressed by setting settings.openOnFocus to false.
			// However, there is a load of items taking place immediately and once it is
			// finished, the items are refreshed and if the selectized control is the
			// currently focused element (checked through the internal property isFocused),
			// the dropdown is opened again. So this has to be surpressed as well.
			// However, the isFocused property also decides if the '.focus' class is added
			// to the control, so when we set it to false, the indication of focused disappears
			// To fix all this the control is locked until the first load takes place. This
			// allows it to take focus but does not open it
			var firstLoadCalled = false;
			selectizeObjectForElement.on('load', function ($dropdown) {
				if (!firstLoadCalled) {
					selectizeObjectForElement.unlock();
					firstLoadCalled = true;
				}
			});

			// Now we are ready to focus the control
			selectizeObjectForElement.lock();
			selectizeObjectForElement.focus();
		} else {
			var el = $('#' + elementId);
			if (el && el.length) {
				el = $(el[0]);
			} else {
				return;
			}
			// If it is a normal element (e.g. text box) el is now the element.
			// However, for radio button group the element is a div, containing labels and inside them inputs, which have to be focused
			var parent = el.parent();
			if (parent.hasClass('radio-button-group')) {
				// Focus the checked radio button
				var checkedRadioButton = parent.find('button[type=button].active');
				if (checkedRadioButton) {
					checkedRadioButton.focus();
				}
			}
			else {
				el.focus();
				el.scrollToMe();
			}
		}
	}
	catch (ex) {
		console.error(ex);
	}
};
/* END: Focus element */

/* MVC and bootstrap use different css classes to mark errors */
window.prepareFormsForBootstrapErrors = function () {
	// Fix for client side validation
	$('form').each(function () {
		try {
			var form = $(this);
			var settings = form.validate().settings;
			settings.highlight = function (element, errorClass, validClass) {
				$(element).parents('.form-group').addClass('has-error');
			};
			settings.unhighlight = function (element, errorClass, validClass) {
				$(element).parents('.form-group').removeClass('has-error');
			};

			// Another option that also works and gives access to the label (the validation message span)
			/*
			var formData = form.data();
			var settings = formData.validator.settings;
			// Store existing event handlers in local variables
			var oldErrorPlacement = settings.errorPlacement;
			var oldSuccess = settings.success;

			settings.errorPlacement = function (label, element) {
				try {
					// Note: label is the validation message span
					// Call old handler so it can update the HTML
					oldErrorPlacement(label, element);

					// Add Bootstrap classes to newly added elements
					label.parents('.form-group').addClass('has-error');
				} catch (e) {
					console.log(e);
				}
			};

			settings.success = function (label) {
				// Note: label is the validation message span
				// Remove error class from <div class="row form-group">
				label.parents('.form-group').removeClass('has-error');

				// Call old handler to do rest of the work
				oldSuccess(label);
			};
			*/

		} catch (e) {
			console.log("prepareFormsForBootstrapErrors: " + e + " for:");
			console.log(this);
		}
	});

	// Fix for server side validation
	$('.input-validation-error').parents('.form-group').addClass('has-error');
	$('.field-validation-error').addClass('text-danger');
};

/* Sets alternative button actions; used when a single form has more than one button */
window.setButtonFormActions = function () {
	$('[data-custom-form-action]').click(function (e) {
		try {
			var form = $(this).closest('form');
			if (form !== null) {
				form.attr('action', $(this).attr('data-custom-form-action'));
				return true;
			}
		} catch (err) {
			console.log(err);
		}
		e.preventDefault();
		e.stopImmediatePropagation();
		return false;
	});
};

/* Adds confirmation to a button and executes the click only if confirmed by the user */
window.setButtonConfirmations = function () {
	$('[data-custom-confirmation]').each(function () {
		try {
			var el = $(this);
			// If the element has an onclick event, it is called BEFORE this handler, so copy it and clear it
			var onClick = el.attr("onclick");
			el.attr("onclick", null);

			el.click(function (e) {
				if (window.confirm(el.attr('data-custom-confirmation'))) {
					doNotWarnOnPageLeave();
					if (onClick) {
						eval(onClick); // Execute the stored onclick function
					}
					return true;
				} else {
					e.preventDefault();
					e.stopImmediatePropagation();
					return false;
				}
			});
		} catch (err) {
			console.log(err);
		}
	});
};

/* Alerts */
window.showAlert = function (parentId, resultMessageType, resultMessage) {
	var resultDiv = document.getElementById(parentId);
	resultDiv.innerHTML =
		'<div id="alertJS" class="alert alert-' + resultMessageType + ' alert-dismissible">\
			<button type="button" class="close" data-dismiss="alert"><span>&times;</span></button>\
			<p>' + resultMessage + '</p>\
		</div>';
	$('#alertJS').on('close.bs.alert', function (e) {
		resultDiv.style.display = "none";
	});
	resultDiv.style.display = "block";
};

window.removeResultSubElementsOnAlertClose = function () {
	$('.alert')
		.bind('closed.bs.alert',
			function () {
				document.getElementById("layoutResult").innerHTML = '';
			});
};


/* On load */
$(function () {
	$('[data-toggle="tooltip"]').tooltip();	// Activate boostrap tooltips
	prepareFormsForBootstrapErrors();
	setActiveSidebarElement();
	setButtonConfirmations();	// Put this before any other click processing
	setButtonFormActions();
	removeResultSubElementsOnAlertClose();
	if (Popper.Defaults) {
		Popper.Defaults.modifiers.computeStyle.gpuAcceleration = !(window.devicePixelRatio < 1.5 && /Win/.test(navigator.platform));
	}
});

/* Extended decodeURIComponentEx */
window.decodeURIComponentEx = function (val) {
	// decodeURIComponent ignores +, so convert it first to space
	return decodeURIComponent(val.replace(/\+/g, '%20'));
};

window.encodeURIComponentEx = function (val) {
	// opposite of decodeURIComponent
	return encodeURIComponent(val).replace(/%20/g, '+');
};

// Calls a function which is provided directly as parameter or name of a function defined on window level
window.callFunction = function (func) {
	if (func) {
		if (typeof func === "function")
			func();
		else {
			if (!(typeof window[func] === "function"))
				console.error(`window[${func}] is not a function`);
			else
				window[func]();
		}
	}
};

/* Popover */
window.popOverForIconButton = function (identifier, placement, content, popoverClass, activateLongTabOnMobile, onClickFunction = null) {
	var selector = '[data-ident="button_' + identifier + '"]';

	popOver(selector, placement, content, popoverClass, activateLongTabOnMobile, onClickFunction, identifier);
};

window.popOver = function (selector, placement, content, popoverClass, activateLongTabOnMobile, onClickFunction = null, popoverIdent = null) {
	if (popoverIdent === null) {
		popoverIdent = newGuid();
	}
	var popoverSelectorDataAttribute = 'data-popover-ident="popover_' + popoverIdent + '"';
	var popoverSelector = '[' + popoverSelectorDataAttribute + ']';

	var myDefaultWhiteList = $.fn.popover.Constructor.Default.whiteList;
	myDefaultWhiteList.div = ['data-popover-ident'];
	myDefaultWhiteList.header = [];
	myDefaultWhiteList.h4 = [];

	$(selector)
		.popover({
			placement: placement,
			trigger: 'manual',
			// Template taken from bootstrap and enhanced
			template: '<div class="popover ' + popoverClass + '" role="tooltip" ' + popoverSelectorDataAttribute + '><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
			container: 'body',
			html: true,
			content: content
		});
	if (window.isMobileBrowser() && activateLongTabOnMobile) {
		// prepare longTap functionality
		$(selector).click(function (event) {
			// Here "this" is the dom object
			if (this.lastClickWasLongTap) {
				event.preventDefault();
			}
			this.lastClickWasLongTap = false;
			return false;
		});
		$(selector).addClass("preventMenuOnLongTap");
		$(selector).swipe({
			longTap: function (event, target) {
				// Here "this" is already the jQuery object
				this.popover("show");

				setTimeout(function () {
					$(selector).popover("hide");
				},
					7000
				);
				$(popoverSelector).on("click",
					function () {
						$(this).popover("hide");
					});

				this[0].lastClickWasLongTap = true;
			},
			tap: function (event, target) {
				callFunction(onClickFunction);
			},
			threshold: 50
		});
	} else {
		$(selector)
			.on("mousemove",
				function () {
					var me = this;
					$(me).popover("show");

					var popover = $(popoverSelector);
					popover.on("mouseleave",
						function () {
							$(selector).popover("hide");
						});
				})
			.on("mouseleave",
				function () {
					if ($(popoverSelector + '.show:hover').length < 1) {
						$(selector).popover("hide");
					}
				})
			.on("click", function () {
				if (onClickFunction) {
					callFunction(onClickFunction);
				}
				return false;
			});
	}
};

/* User warning before leaving page */
window.warnOnPageLeaveHandler = null;
window.warnOnPageLeave = function (message) {
	doNotWarnOnPageLeave();
	warnOnPageLeaveHandler = function () {
		return message;
	};
	$(window).bind('beforeunload', warnOnPageLeaveHandler);
};

window.doNotWarnOnPageLeave = function () {
	if (warnOnPageLeaveHandler) {
		$(window).unbind('beforeunload', warnOnPageLeaveHandler);
		warnOnPageLeaveHandler = null;
	}
};

window.alertCustomOnClick = function (elementId, title, message, redirectTo, icon, getArgumentProvidingElementId = null) {

	/// <summary>
	/// Binds a click event to the jQuery object with elementId. Shows a swal popup
	/// </summary>
	/// <param name="title">Shown on top of the inner content, can be null</param>
	/// <param name="message">Appears within the box under the faIcon</param>
	/// <param name="redirectTo">Determines action to take when user input is positive confirmation, see below for possible values</param>
	/// <param name="faIcon">Icon to be shown within content box on top of inner content</param>
	/// <param name="getArgumentProvidingElementId"> to build urls such as ../delete/a8ab05a3-20f1-4898-a01f-a9b7012bce1e, use Url.RouteUrl + '/' in combination with an element holding the target id </param>	
	/// redirectTo:
	/// 'submit' --> submit next parent form
	/// 'href' --> submit with element's href
	/// external url,
	/// undefined/null --> just alert the user and do nothing
	$('#' + elementId).click(function (e) {
		e.preventDefault(); //cancel default action
		var alertOnly = false;
		var thenFunction = null;
		if (redirectTo === 'submit') {
			var form = $(this).parents('form');
			thenFunction = function (result) {
				if (result) {
					form.submit();
				} else {
					return;
				}
			};
		}
		else if (redirectTo === 'href') {
			//Recuperate href value
			var href = $(this).attr('href');
			thenFunction = function (result) {
				if (result) {
					window.location.href = href;
				} else {
					return;
				}
			};
		}
		else if (!redirectTo) {
			alertOnly = true;
			thenFunction = function (result) {
				return;
			};
		}
		else if (getArgumentProvidingElementId) {
			var targetUrl = redirectTo + $('#' + getArgumentProvidingElementId).val();
			thenFunction = function (result) {
				if (result) {
					window.location.href = targetUrl;
				} else {
					return;
				}
			};
		}
		SwalEx.alertCustom(title, message, thenFunction, alertOnly, icon);
	});
};

/* Image full view on click */
window.showFullImageOnClick = function (selector) {
	var $imgFullDiv = $('<div />').appendTo('body');
	$imgFullDiv.addClass('img-full hidden');

	$(selector).on('click', function () {
		// Helper for vertical align
		var $imgFullHelper = $('<span />').appendTo($imgFullDiv);
		$imgFullHelper.addClass('img-full-helper');

		$imgFullDiv
			.append($(this).clone())
			.removeClass('hidden');
	});

	$imgFullDiv.on('click', function () {
		$imgFullDiv.empty().addClass('hidden');
	});
};
/* End Image full view on click */

/* Guid support */
window.newGuid = function () {
	return ("" + 1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(/1|0/g, function () {
		return (0 | Math.random() * 16).toString(16);
	});
};

window.isGuid = function (val) {
	return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(val);
};
/* End Guid support */

window.disableButton = function (btnId) {
	var btn = document.getElementById(btnId);
	btn.disabled = true;
};